import axiosRequest from '@/utils/axiosRequest'

export function bill(data) {
    return axiosRequest({
      url: `/account/bill`,
      data,
      method: 'post'
    })
  }